<mat-toolbar class="st-top-bar-toolbar">
    <mat-toolbar-row>
        @if (mobileSidebarToggleButtonVisible()) {
            <button
                mat-icon-button
                class="st-top-bar-menu"
                (click)="toggleSideBar.emit()">
                <mat-icon
                    fontSet="material-symbols-outlined"
                    class="st-top-bar-icon">
                    menu
                </mat-icon>
            </button>
        }
        <span class="st-top-bar__title">{{ label() }}</span>
        <div class="st-top-bar-button-group">
            @if (isCurrentAppSearchEnabled()) {
                <st-search-box />
            }
            @if (viewHasFilter()) {
                <button
                    mat-icon-button
                    [matTooltip]="languageSettings().PSTWebFilterLabel"
                    (click)="toggleFilter.emit()">
                    <mat-icon>filter_alt</mat-icon>
                </button>
            }
            @if (!viewHasFilter()) {
                <button
                    mat-icon-button
                    (click)="toggleFilter.emit()">
                    <mat-icon>view_sidebar</mat-icon>
                </button>
            }
            <st-top-bar-user-menu />
        </div>
    </mat-toolbar-row>
</mat-toolbar>
